import {useEffect, useRef} from 'react';

import {useGlobalFulfillmentDetail} from '@/components/global/providers/GlobalFulfillmentDetailProvider';
import {useEventBarV2} from '../EventBarV2Provider';
import useFilterSearchSignature from './useFilterSearchSignature';

// Applying a filter runs a new search against the *persisted* fulfillment detail, so Where/When/Who
// edits the user staged in the bar but never submitted were no part of it. Roll them back rather
// than leave the bar describing a search that isn't the one on screen. The bar's own search commits
// the staged values first, which makes this a no-op. Skipped without a detail to revert to, so a
// half-entered address on a detail-less page isn't thrown away.
const useRevertStagedOnFilterSearch = (): void => {
  const {fulfillmentDetail} = useGlobalFulfillmentDetail();
  const {resetToFulfillmentDetail} = useEventBarV2();
  const filtersSignature = useFilterSearchSignature();
  const previousFiltersSignatureRef = useRef(filtersSignature);

  useEffect(() => {
    if (previousFiltersSignatureRef.current === filtersSignature) return;
    previousFiltersSignatureRef.current = filtersSignature;
    if (!fulfillmentDetail) return;
    resetToFulfillmentDetail();
  }, [filtersSignature, fulfillmentDetail, resetToFulfillmentDetail]);
};

export default useRevertStagedOnFilterSearch;
